"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Version", {
  enumerable: true,
  get: function get() {
    return _version.Version;
  }
});

var _version = require("./version");


//////////////////
// WEBPACK FOOTER
// ./~/@weike/toolkit/lib/version/index.js
// module id = 625
// module chunks = 6